(() => {
  if (window.__vskloCollectionSetMoreBound) return;
  window.__vskloCollectionSetMoreBound = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-collection-set-more]');
    if (!button) return;

    const section = button.closest('[data-collection-set]');
    if (!section) return;

    const extra = section.querySelector('.collection-set__extra');
    const allLinkTemplate = section.querySelector('template[data-collection-set-all-template]');
    const allLink = allLinkTemplate?.content.firstElementChild;
    if (!extra || !allLink) return;

    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    if (isExpanded) return;

    const extraTemplate = section.querySelector('template[data-collection-set-extra-template]');
    if (extraTemplate && extra.dataset.vskloMaterialized !== 'true') {
      extra.appendChild(extraTemplate.content.cloneNode(true));
      extra.dataset.vskloMaterialized = 'true';
      document.dispatchEvent(new CustomEvent('vsklo:content-updated', {
        detail: { scope: extra }
      }));
    }

    extra.hidden = false;
    const catalogLink = allLink.cloneNode(true);
    button.replaceWith(catalogLink);
    catalogLink.focus({ preventScroll: true });
  });
})();


/* Mobile collection carousel: native touch scrolling with centered snap points. */
(() => {
  const initialized = new WeakSet();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    const slider = section?.querySelector('[data-collection-set-mobile-slider]');
    if (!slider || initialized.has(slider)) return;
    const viewport = slider.querySelector('[data-collection-set-mobile-viewport]');
    const slides = Array.from(slider.querySelectorAll('.collection-set__mobile-slide'));
    const previous = slider.querySelector('[data-collection-set-mobile-prev]');
    const next = slider.querySelector('[data-collection-set-mobile-next]');
    if (!viewport || !slides.length) return;
    initialized.add(slider);

    const update = () => {
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      if (previous) previous.disabled = viewport.scrollLeft <= 2;
      if (next) next.disabled = viewport.scrollLeft >= maxScroll - 2;
    };
    const move = (direction) => {
      const viewportBounds = viewport.getBoundingClientRect();
      const viewportCenter = viewportBounds.left + viewportBounds.width / 2;
      const active = slides.reduce((closest, slide) => {
        const bounds = slide.getBoundingClientRect();
        const distance = Math.abs(bounds.left + bounds.width / 2 - viewportCenter);
        return distance < closest.distance ? { slide, distance } : closest;
      }, { slide: slides[0], distance: Infinity }).slide;
      const currentIndex = slides.indexOf(active);
      const target = slides[Math.max(0, Math.min(slides.length - 1, currentIndex + direction))];
      if (!target) return;
      const bounds = target.getBoundingClientRect();
      viewport.scrollTo({
        left: viewport.scrollLeft + bounds.left - viewportBounds.left - (viewport.clientWidth - bounds.width) / 2,
        behavior: motion.matches ? 'auto' : 'smooth'
      });
    };

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    viewport.addEventListener('scroll', update, { passive: true });
    viewport.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      move(event.key === 'ArrowLeft' ? -1 : 1);
    });
    if (typeof ResizeObserver === 'function') new ResizeObserver(update).observe(viewport);
    update();
  }

  function boot(root) {
    if (root?.matches?.('[data-collection-set]')) init(root);
    root?.querySelectorAll?.('[data-collection-set]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
  else boot(document);
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();


/* Category carousel: the same Swiper 11 runtime used by VSKLO Bestsellers.
   Swiper owns movement, touch inertia, and native infinite looping. */
(() => {
  if (window.__vskloCollectionSetSwiperBound) return;
  window.__vskloCollectionSetSwiperBound = true;

  const instances = new WeakMap();
  const loading = new WeakSet();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const preloadObserver = typeof IntersectionObserver === 'function'
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          preloadObserver.unobserve(entry.target);
          mount(entry.target);
        });
      }, { rootMargin: '650px 0px' })
    : null;

  function mount(section) {
    const slider = section.querySelector('[data-collection-set-slider]');
    if (!slider || instances.has(slider) || loading.has(slider)) return;
    const viewport = slider.querySelector('[data-collection-set-viewport]');
    const track = slider.querySelector('[data-collection-set-track]');
    if (!viewport || !track) return;

    // Editor reinitialization: only the six/eight+ authored cards are content.
    // Remove transient loop mirrors before counting slides or creating Swiper.
    track.querySelectorAll(':scope > .collection-set__slide[data-vsklo-loop-mirror]').forEach((slide) => slide.remove());
    const cards = Array.from(track.children).filter((card) => card.classList.contains('collection-set__slide'));
    const count = cards.length;
    if (!count) return;

    const cleanupMirrors = () => {
      track.querySelectorAll(':scope > .collection-set__slide[data-vsklo-loop-mirror]').forEach((slide) => slide.remove());
      cards.forEach((slide) => { delete slide.dataset.vskloOriginalIndex; });
    };

    // Swiper follows the finger; native anchor/image drag must never hijack it.
    cards.forEach((slide) => {
      const link = slide.querySelector('.collection-set__item');
      if (link) link.draggable = false;
      slide.querySelectorAll('img').forEach((img) => { img.draggable = false; });
    });
    const prefetchNeighbours = (index) => {
      [-2, -1, 0, 1, 2, 3].forEach((offset) => {
        const slide = cards[((index + offset) % count + count) % count];
        const img = slide?.querySelector('.collection-set__image');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      });
    };

    const prev = slider.querySelector('[data-collection-set-prev]');
    const next = slider.querySelector('[data-collection-set-next]');
    const counter = slider.querySelector('[data-collection-set-current]');
    const total = slider.querySelector('[data-collection-set-total]');
    const previousTabindex = viewport.getAttribute('tabindex');

    slider.dataset.slideCount = String(count);
    if (total) total.textContent = String(count).padStart(2, '0');
    if (count === 1) {
      slider.dataset.sliderReady = 'true';
      slider.dataset.slideIndex = '1';
      instances.set(slider, { destroy() { delete slider.dataset.sliderReady; } });
      return;
    }

    loading.add(slider);
    let attempts = 0;
    const ensureRuntime = () => {
      if (!section.isConnected) return Promise.resolve();
      const ready = typeof window.vskloEnsureSwiper === 'function'
        ? window.vskloEnsureSwiper()
        : window.Swiper ? Promise.resolve() : Promise.reject(new Error('VSKLO Swiper loader unavailable'));
      return Promise.resolve(ready).catch((error) => {
        if (++attempts >= 3 || !section.isConnected) throw error;
        return new Promise((resolve) => window.setTimeout(resolve, attempts * 700)).then(ensureRuntime);
      });
    };

    ensureRuntime().then(() => {
      if (!section.isConnected || !window.Swiper) return;

      // Reuse the canonical Bestsellers' small-collection loop strategy.
      // Swiper 11 needs more DOM slides than the largest fractional viewport.
      // Mirrors exist only at runtime: the Theme Editor keeps the exact
      // authored collection blocks, images, links and 01/06 counter.
      const needsLoopMirrors = count >= 3 && count < 8;
      if (needsLoopMirrors) {
        const target = Math.ceil(Math.max(8, count * 2) / count) * count;
        cards.forEach((slide, index) => {
          slide.dataset.vskloOriginalIndex = String(index);
        });
        for (let index = count; index < target; index += 1) {
          const mirror = cards[index % count].cloneNode(true);
          mirror.dataset.vskloLoopMirror = 'true';
          mirror.dataset.vskloOriginalIndex = String(index % count);
          if (mirror.id) mirror.removeAttribute('id');
          mirror.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
          mirror.removeAttribute('data-shopify-editor-block');
          mirror.querySelectorAll('[data-shopify-editor-block]').forEach((element) => element.removeAttribute('data-shopify-editor-block'));
          mirror.querySelectorAll('a,img').forEach((element) => { element.draggable = false; });
          track.appendChild(mirror);
        }
      }
      const canLoop = count >= 8 || needsLoopMirrors;

      const events = new AbortController();
      const signal = events.signal;
      let swiper;
      const updateCounter = (instance) => {
        if (!instance || instance.destroyed) return;
        const activeSlide = instance.slides?.[instance.activeIndex];
        const originalIndex = Number(activeSlide?.dataset.vskloOriginalIndex);
        const current = needsLoopMirrors && Number.isFinite(originalIndex)
          ? originalIndex : ((Number(instance.realIndex) || 0) % count + count) % count;
        slider.dataset.slideIndex = String(current + 1);
        if (counter) counter.textContent = String(current + 1).padStart(2, '0');
        prefetchNeighbours(current);
      };

      // Set ready BEFORE creating Swiper, so its first size measurement never
      // includes both our fallback flex gap and Swiper's spaceBetween.
      slider.dataset.sliderReady = 'true';
      viewport.setAttribute('tabindex', '0');

      try {
        swiper = new window.Swiper(viewport, {
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 12,
          breakpoints: { 768: { spaceBetween: 14 } },
          speed: reduceMotion.matches ? 0 : 500,
          effect: 'slide',
          loop: canLoop,
          rewind: !canLoop,
          loopAdditionalSlides: 2,
          loopPreventsSliding: true,
          slidesPerGroup: 1,
          mousewheel: {
            forceToAxis: true,
            thresholdDelta: 24,
            thresholdTime: 350,
            releaseOnEdges: false
          },
          grabCursor: true,
          simulateTouch: true,
          allowTouchMove: true,
          followFinger: true,
          // Mouse pointerdown must be claimed by Swiper before Chromium starts
          // the native link/image drag or text selection.
          touchStartPreventDefault: true,
          threshold: 2,
          longSwipes: true,
          shortSwipes: true,
          preventClicks: true,
          preventClicksPropagation: true,
          watchSlidesProgress: true,
          roundLengths: false,
          resizeObserver: true,
          updateOnWindowResize: true,
          a11y: { enabled: true, slideRole: 'group' },
          on: {
            init(instance) { updateCounter(instance); },
            realIndexChange(instance) { updateCounter(instance); }
          }
        });
      } catch (error) {
        events.abort();
        delete slider.dataset.sliderReady;
        if (previousTabindex === null) viewport.removeAttribute('tabindex');
        else viewport.setAttribute('tabindex', previousTabindex);
        cleanupMirrors();
        throw error;
      }

      if (!swiper || swiper.destroyed || !swiper.initialized) {
        delete slider.dataset.sliderReady;
        if (previousTabindex === null) viewport.removeAttribute('tabindex');
        else viewport.setAttribute('tabindex', previousTabindex);
        cleanupMirrors();
        throw new Error('Category Swiper failed to initialize');
      }

      prev && (prev.disabled = false);
      next && (next.disabled = false);

      // Bestsellers' 500ms movement, with a bounded queue so impatient clicks
      // never interrupt a transition or trigger Swiper loopFix mid-animation.
      let pendingSteps = 0;
      const slide = (direction) => {
        if (swiper.destroyed) return;
        const delta = direction < 0 ? -1 : 1;
        if (swiper.animating) {
          pendingSteps = Math.max(-count, Math.min(count, pendingSteps + delta));
          return;
        }
        if (delta < 0) swiper.slidePrev();
        else swiper.slideNext();
      };
      swiper.on('transitionEnd', () => {
        if (!pendingSteps || swiper.destroyed) return;
        const direction = Math.sign(pendingSteps);
        pendingSteps -= direction;
        window.requestAnimationFrame(() => slide(direction));
      });
      swiper.on('touchStart', () => { pendingSteps = 0; });

      // Dragging over collection links must never start the browser's native
      // drag-and-drop gesture, which otherwise cancels Swiper pointermove.
      viewport.addEventListener('dragstart', (event) => {
        if (event.target.closest('.collection-set__slide')) event.preventDefault();
      }, { capture: true, signal });

      prev?.addEventListener('click', () => slide(-1), { signal });
      next?.addEventListener('click', () => slide(1), { signal });
      viewport.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
        event.preventDefault();
        slide(event.key === 'ArrowLeft' ? -1 : 1);
      }, { signal });

      // A visible 30% side card navigates; a fully visible card opens its collection.
      viewport.addEventListener('click', (event) => {
        const card = event.target.closest('.collection-set__slide.swiper-slide');
        if (!card || !viewport.contains(card) || swiper.destroyed || !swiper.allowClick) return;
        const bounds = card.getBoundingClientRect();
        const frame = viewport.getBoundingClientRect();
        const atLeft = bounds.left < frame.left - 2;
        const atRight = bounds.right > frame.right + 2;
        if (!atLeft && !atRight) return;
        event.preventDefault();
        event.stopPropagation();
        slide(atLeft ? -1 : 1);
      }, { capture: true, signal });

      // Trackpad wheel gestures are delegated to Swiper's mousewheel module;
      // forceToAxis preserves normal vertical page scroll.

      reduceMotion.addEventListener?.('change', () => {
        if (!swiper.destroyed) swiper.params.speed = reduceMotion.matches ? 0 : 500;
      }, { signal });

      section.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('.collection-set__slide');
        const index = cards.indexOf(card);
        if (index < 0 || swiper.destroyed) return;
        if (swiper.params.loop) swiper.slideToLoop(index, 0);
        else swiper.slideTo(index, 0);
      }, { signal });

      updateCounter(swiper);
      instances.set(slider, {
        destroy() {
          events.abort();
          pendingSteps = 0;
          if (swiper && !swiper.destroyed) swiper.destroy(true, true);
          cleanupMirrors();
          delete slider.dataset.sliderReady;
          delete slider.dataset.slideIndex;
          if (previousTabindex === null) viewport.removeAttribute('tabindex');
          else viewport.setAttribute('tabindex', previousTabindex);
          if (prev) prev.disabled = true;
          if (next) next.disabled = false;
        }
      });
    }).catch((error) => {
      // Keep the accessible, native horizontal-scroll fallback available.
      cleanupMirrors();
      delete slider.dataset.sliderReady;
      if (window.VSKLO_DEBUG) console.warn('[VSKLO] Category Swiper:', error);
    }).finally(() => {
      loading.delete(slider);
    });
  }

  function observe(section) {
    if (!section || !section.querySelector('[data-collection-set-slider]')) return;
    if (window.Shopify?.designMode || !preloadObserver) mount(section);
    else preloadObserver.observe(section);
  }
  function sections(root) {
    if (!root) return [];
    const items = root.matches?.('[data-collection-set]') ? [root] : [];
    root.querySelectorAll?.('[data-collection-set]').forEach((item) => items.push(item));
    return items;
  }
  function boot(root) {
    sections(root).forEach(observe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    sections(event.target).forEach((section) => {
      if (preloadObserver) preloadObserver.unobserve(section);
      const slider = section.querySelector('[data-collection-set-slider]');
      if (!slider) return;
      instances.get(slider)?.destroy();
      instances.delete(slider);
    });
  });
})();
